import { useShallow } from "zustand/react/shallow";
import { useExplorerStore } from "../store";
import type { FilterComponent, WrapProps } from "../types";

export default function FiltersWrap({
	component: Component,
}: WrapProps<FilterComponent>) {
	const { config, ...props } = useExplorerStore(
		useShallow(
			({
				doFilter: onFilter,
				doFilterReset: onReset,
				activeFilters,
				config,
				doGetFilterOptionResultsCount,
				activeSearch,
			}) => ({
				onFilter,
				onReset,
				activeFilters,
				config,
				filterOptionCountFn: doGetFilterOptionResultsCount,
				activeSearch,
			}),
		),
	);
	return <Component {...props} filtersConfig={config?.filter} />;
}
